import { PyContextWrapper, PyStateWrapper, getPyodideLoader, pyodideInitialize, } from "./python";
import { loadPystdlib, pyodideWrapperInit } from "./python/index";
import { pystdlibsrc } from "../../stdlib/py/pystdlib";
const PYODIDE_URL = "https://cdn-us1.hash.ai/pyodide-0.17.0-patch/";
class NamespaceMap {
    constructor() {
        this.namespaces = new Map();
    }
    async new(name) {
        const ns = await initPythonNamespace();
        this.namespaces.set(name, ns);
        return ns;
    }
    async applyAll(f) {
        for (const ns of this.namespaces.values()) {
            f(ns);
        }
    }
}
export const globalNamespaces = new NamespaceMap();
export const pyStateWrapper = new PyStateWrapper();
export const pyContextWrapper = new PyContextWrapper();
export let runnerPython = null;
export const runPythonNamespaced = async (code, namespace, messageCallback, errorCallback) => {
    await runnerPython?.loadPackagesFromImports(code, messageCallback, errorCallback);
    const coroutine = runnerPython?.pyodide_py.eval_code_async(code, namespace);
    try {
        const result = await coroutine;
        return result;
    }
    finally {
        coroutine.destroy();
    }
};
export const buildPyodide = async () => {
    if (typeof global === "object" &&
        typeof require === "function" &&
        global.hasOwnProperty("pythonLoader")) {
        try {
            runnerPython = await global.pythonLoader();
        }
        catch (err) {
            console.error("No pyodide loader provided!", err);
        }
    }
    else {
        getPyodideLoader();
        runnerPython = await self.loadPyodide({ indexURL: PYODIDE_URL });
        console.log(`Using Pyodide ${self.pyodide.version}`);
    }
    return runnerPython;
};
export const initPythonNamespace = async () => {
    const namespace = self.pyodide.toPy({});
    await runPythonNamespaced(pyodideInitialize, namespace);
    namespace.set("pystdlibSource", pystdlibsrc);
    namespace.set("pyContextWrapper", pyContextWrapper);
    namespace.set("pyStateWrapper", pyStateWrapper);
    namespace.set("simGlobals", "{}");
    namespace.set("pyStateCache", "{}");
    namespace.set("updateGlobals", true);
    await runPythonNamespaced(loadPystdlib, namespace);
    await runPythonNamespaced(pyodideWrapperInit, namespace);
    return namespace;
};
export const updatePythonGlobals = (globals) => {
    if (runnerPython !== null) {
        globalNamespaces.applyAll((ns) => {
            ns.set("simGlobals", globals);
            ns.set("updateGlobals", true);
            ns.set("simGlobals", globals);
        });
    }
};
export const updatePythonDatasetCache = (datasets) => {
    if (runnerPython !== null) {
        globalNamespaces.applyAll((ns) => {
            ns.set("cached_datasets", datasets);
        });
    }
};
export const isPyodideLoaded = () => runnerPython !== null;
//# sourceMappingURL=buildpython.js.map